module.exports = __webpack_public_path__ + "static/img/SFU校区.273d604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/SFU/SFU校区.png
// module id = Xvqu
// module chunks = 0